module.exports = __webpack_public_path__ + "media/newstyle/images/img-footer-eeea03603b5d0e2516cf8b35db14cbae.svg";